
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 34.388 34.461"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"phone-call(32)"}},[_c('g',{attrs:{"data-name":"Group 759"}},[_c('path',{attrs:{"data-name":"Path 6941","d":"M33.487 25.291l-4.809-4.809a3.2 3.2 0 00-5.324 1.2 3.273 3.273 0 01-3.779 2.061c-3.435-.859-8.072-5.324-8.931-8.931a3.113 3.113 0 012.061-3.779 3.2 3.2 0 001.2-5.324L9.098.9a3.43 3.43 0 00-4.637 0L1.197 4.165C-2.066 7.6 1.541 16.7 9.613 24.775s17.175 11.851 20.61 8.416l3.263-3.263a3.43 3.43 0 00.001-4.637z","fill":"#3d9ed3"}})])])])
          )
        }
      }
    